import { useState } from 'react'
import {
  ExclamationCircleIcon,
  CheckCircleIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/solid'

import { AuthUser } from '../../store/slices/userSlice.types'

export function EmailVerification({
  user,
  sendVerificationEmail,
}: {
  user: AuthUser
  sendVerificationEmail: () => void
}) {
  const [isSending, setIsSending] = useState(false)
  const [message, setMessage] = useState('')

  const handleSendVerification = async () => {
    setIsSending(true)
    setMessage('')
    try {
      await sendVerificationEmail()
      setMessage('Verification email sent. Please check your inbox.')
    } catch (error) {
      setMessage('Failed to send verification email. Please try again.')
    }
    setIsSending(false)
  }

  return (
    <div className="bg-white shadow sm:rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          Email Verification
        </h3>
        <div className="mt-2 max-w-xl text-sm text-gray-500">
          <p>Your email address: {user.email}</p>
        </div>
        <div className="mt-3 text-sm">
          {user.emailVerified ? (
            <div className="flex items-center text-green-600">
              <CheckCircleIcon className="h-5 w-5 mr-2" aria-hidden="true" />
              Your email is verified
            </div>
          ) : (
            <div className="flex items-center text-yellow-600">
              <ExclamationCircleIcon
                className="h-5 w-5 mr-2"
                aria-hidden="true"
              />
              Your email is not verified
            </div>
          )}
        </div>
        {!user.emailVerified && (
          <div className="mt-5">
            <button
              type="button"
              onClick={handleSendVerification}
              disabled={isSending}
              className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
            >
              {isSending ? (
                'Sending...'
              ) : (
                <>
                  <EnvelopeIcon className="mr-2 h-4 w-4" aria-hidden="true" />
                  Send Verification Email
                </>
              )}
            </button>
            {message && <p className="mt-2 text-sm text-gray-500">{message}</p>}
          </div>
        )}
      </div>
    </div>
  )
}
